import { render, staticRenderFns } from "./SectionApprovals.vue?vue&type=template&id=6343db38&"
import script from "./SectionApprovals.vue?vue&type=script&lang=js&"
export * from "./SectionApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports